import React from "react";
import locale from "locale";
import {
    Modal,
    Button,
    FormGroup,
    ControlLabel,
    FormControl,
    Row,
    Col,
} from "react-bootstrap";

import { MAIL_SUBJECT_PLACEHOLDERS } from "../constants";
import {ucFirst} from "../../../../../admin/js/lib";

const EmailTemplateLayoutModel = ({
    event,
    isModalVisible,
    templates,
    createReminder,
    onClose,
}) => {
    const [inProgress, setInProgress] = React.useState(false);
    const [templateId, setTemplateId] = React.useState("");
    const [subjects, updateSubjects] = React.useReducer(
        (prev, next) => {
            return { ...prev, ...next };
        },
        {
            subjectEn: "",
            subjectRu: "",
        }
    );

    React.useEffect(() => {
        if (templates && templates.length) {
            handleTemplates(templates[0]?.id);
        }

        return () => {
            setInProgress(false);
        };
    }, [templates]);

    function handleCreate() {
        if (inProgress) {
            return;
        }

        if (!templateId) {
            alert(locale("reminders.setTemplate"));

            return;
        }

        if (!(subjects.subjectRu?.trim() && subjects.subjectEn?.trim())) {
            alert(locale("reminders.setReminderSubject"));

            return;
        }

        createReminder(templateId, subjects);
        setInProgress(true);
    }

    function handleTemplates(templateId) {
        const id = parseInt(templateId);
        setTemplateId(id);
        const template = templates.find((template) => template.id === id);
        updateSubjects({
            subjectRu: template?.themeRu ?? '',
            subjectEn: template?.themeEn ?? '',
        });
    }

    const placeholders = [
        ...MAIL_SUBJECT_PLACEHOLDERS,
        'userName',
        event.registrationFields.map(({field}) => 'user' + ucFirst(field.name)),
    ]

    return (
        <Modal show={isModalVisible} bsSize="large">
            <Modal.Header>
                <Modal.Title>
                    {locale("reminders.setTemplateAndTopic")}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row>
                    <Col xs={12}>
                        <FormGroup>
                            <ControlLabel>
                                {locale("reminders.mailTemplate")}
                            </ControlLabel>
                            <FormControl
                                componentClass="select"
                                value={templateId}
                                onChange={({ target }) =>
                                    handleTemplates(target.value)
                                }
                            >
                                {templates.map(({ id, name }) => (
                                    <option key={id + name} value={id}>
                                        {name}
                                    </option>
                                ))}
                            </FormControl>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <FormGroup>
                            <ControlLabel>
                                {locale("reminders.mailSubject")} (Ru)
                            </ControlLabel>
                            <FormControl
                                type="text"
                                value={subjects.subjectRu}
                                onChange={({ target }) =>
                                    updateSubjects({ subjectRu: target.value })
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={6}>
                        <FormGroup>
                            <ControlLabel>
                                {locale("reminders.mailSubject")} (En)
                            </ControlLabel>
                            <FormControl
                                type="text"
                                value={subjects.subjectEn}
                                onChange={({ target }) =>
                                    updateSubjects({ subjectEn: target.value })
                                }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <p>
                    <i>
                        {locale("reminders.availableValues")}:{" "}
                        {placeholders.map((name) => `${name}`).join(", ")}
                    </i>
                </p>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle="success" onClick={handleCreate}>
                    {locale("reminders.choose")}
                </Button>
                <Button onClick={onClose}>{locale("reminders.cancel")}</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EmailTemplateLayoutModel;
